import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import appleTvIcon from "../../assets/images/appletv.png";
import iosIcon from "../../assets/images/ios.png";
import fireTvIcon from "../../assets/images/firetv.png";

const SuccessPage = (props) => {
  const navigate = useNavigate();

  const openStore = (e) => {
    e.preventDefault();
    const { platform } = e.target.dataset;
    let url = "";

    switch (platform) {
      case "fire-tv":
        url = "https://www.amazon.com/Credo-LLC/dp/B0F9LR1DGY/ref=sr_1_1?dib=eyJ2IjoiMSJ9.08boKYN2OhHwd_ohs2n8JA.nbFIIml1yGgOXqmVjcPJmiK0rrla6P3fIpGXOn5kYWE&dib_tag=se&keywords=credo&qid=1748328428&s=mobile-apps&sr=1-1";
        break;
      case "apple-tv":
        url = "https://apps.apple.com/us/app/credo-app/id6744193482";
        break;
      case "ios":
        url = "https://apps.apple.com/us/app/credo-app/id6744193482";
        break;
      default:
        return;
    }

    window.open(url, "_blank");
  }

  return (
    <div className="success-page">
      <div className="message-heading">
        Thank you for renting!
      </div>
      <div className="message-text">
        Just a heads up that you can watch the film here on the web by clicking the ‘Watch Now’ button below, or download any of the below apps, sign in with your username and password, and enjoy the film on your smart TV or device. Either way, we hope the film inspires you!
      </div>
      <button className="watch-button" onClick={(e) => { navigate('/home') }}>
        <span className="play-icon"></span>
        <span className="btn-text">Watch Now</span>
      </button>
      {/* <span className="signup-btn">Watch Now</span> */}
      {/* <input className="signup-btn" type="button" onClick={(e) => { navigate('/home') }} value="Watch Now" /> */}
      <div className="icon-wrapper">
        <img src={fireTvIcon} alt="Fire TV" className="platform-icon" data-platform="fire-tv" onClick={openStore} />
        <img src={appleTvIcon} alt="Apple TV" className="platform-icon" data-platform="apple-tv" onClick={openStore} />
        <img src={iosIcon} alt="ios" className="platform-icon" data-platform="ios" onClick={openStore} />
      </div>
    </div>
  );
};

export default SuccessPage;
